<script>
export default {
  name: 'BaseAlert',
  props: {
    showClose: {
      type: Boolean,
    },
    status: {
      type: String,
      default: '',
    },
    center: {
      type: Boolean,
    },
    iconColor: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    hiddenIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: true,
    }
  },
  computed: {
    iconName() {
      const icons = {
        success: 'mdi-check-circle-outline',
        info: 'mdi-information-outline',
        warning: 'warning',
        error: 'mdi-close-circle',
        danger: 'mdi-close-circle',
        // default: 'mdi-bell-outline'
      }

      return icons[this.icon] || icons[this.status] || this.icon
    },
    colorIcon() {
      const colorIcons = {
        success: 'green',
        info: '#2F80ED',
        warning: '#BA9309',
        error: '#EB5757',
        danger: '#EB5757',
        default: 'primary',
      }

      return (
        colorIcons[this.iconColor] || colorIcons[this.status] || this.iconColor
      )
    },
  },
  methods: {
    removeAlert() {
      this.fadeOut = true
      // Nenhum consumidor no repo escutava este evento antes (verificado:
      // nenhum outro uso de show-close liga @close no BaseAlert) — emitir
      // aqui não muda comportamento de ninguém, só passa a permitir que o
      // pai saiba que o card foi fechado pelo X (antes só existia via
      // isVisible interno, invisível para fora do componente).
      this.$emit('close')
      setTimeout(() => {
        this.isVisible = false
      }, 300)
    },
  },
}
</script>

<template>
  <div
    v-if="isVisible"
    class="d-flex rounded-xxs base-alert"
    :class="{
      'bg-danger': ['error', 'danger'].includes(status),
      'bg-success': status === 'success',
      'bg-warning': status === 'warning',
      'bg-info': status === 'info',
      'bg-default': status === 'default' || !status,
      'align-items-center': center,
    }"
    style="position: relative"
    v-bind="$attrs"
  >
    <div class="d-flex align-items-center container-icon" style="width: 100%">
      <span
        :style="{
          position: 'absolute',
          left: '0',
          height: '40px',
          width: '2px',
          backgroundColor: colorIcon,
        }"
      />
      <icon-svg
        v-if="!hiddenIcon"
        :name="iconName"
        :color="colorIcon"
        size="40"
      />

      <div
        class="mx-5 text-black"
        style="
          flex: 1 1 auto;
          min-width: 0;
          font-size: 0.875rem;
          color: #4b4b4bee;
        "
      >
        <slot />
      </div>
      <v-spacer />
      <div
        class="base-alert__actions d-flex align-items-center"
        style="gap: 8px; flex-shrink: 0"
      >
        <slot name="button" />
      </div>
      <button
        v-if="showClose"
        data-testid="base-alert-close"
        @click="removeAlert"
      >
        <icon-svg name="mdi-close-circle" color="secondary" size="24" />
      </button>
    </div>
  </div>
</template>

<style lang="sass">
.base-alert
  background-color: #F1F1F1
  padding: 11px 16px
  border-radius: 10px
  &.bg-warning
    background-color: #E0AF0026 !important
  &.bg-danger
    background-color: #EB575726 !important
  &.bg-success
    background-color: #27AE6026 !important
  &.bg-info
    background-color: #2F80ED26 !important
  &.bg-default
    background-color: #F1F1F1 !important
</style>
